import { ReactNode } from "react"
import { Modal } from "../Modal/Modal"
import { BottomBar } from "components/ui/bottomBar/BottomBar"
import style from "./FullscreenContentModal.module.scss"

const { wrapper, body, bar } = style

type Props = {
	isOpen: boolean
	onClose: () => void
	children: ReactNode
	bottomBar?: ReactNode
	className?: string
}

export const FullscreenContentModal = ({ isOpen, onClose, children, bottomBar, className = "" }: Props) => {
	return (
		<Modal
			width="100%"
			isModalOpen={isOpen}
			setModalClose={onClose}
			className={`fullscreenContentModal ${className}`}
		>
			<div className={wrapper} data-testid="fullscreen-content-modal">
				<div className={body}>{children}</div>
				{bottomBar ? <BottomBar className={bar}>{bottomBar}</BottomBar> : null}
			</div>
		</Modal>
	)
}
